import React from 'react'
import { Package, RefreshCw, ArrowLeft } from 'lucide-react'
import ErrorBoundary from './ErrorBoundary'
import { Helmet } from 'react-helmet'
import searchMetadata from '@/data/searchMetadata.json'

interface ProductErrorBoundaryProps {
    children: React.ReactNode
}

const ProductErrorFallback: React.FC = () => {
    const handleGoBack = () => {
        window.history.back()
    }

    const handleReload = () => {
        window.location.reload()
    }

    return (
        <div data-prerender-error="product" data-nosnippet="" role="alert" className="min-h-[400px] flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg">
            <Helmet><title>{searchMetadata.product.title}</title></Helmet>
            <Package className="h-16 w-16 text-gray-400 mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
                We couldn’t load these headphones
            </h2>
            <p className="text-gray-600 text-center mb-6 max-w-md">
                We're having trouble loading this product. This might be a temporary issue.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3">
                <button
                    onClick={handleReload}
                    className="flex items-center gap-2 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                >
                    <RefreshCw className="h-4 w-4" />
                    Try Again
                </button>
                
                <button
                    onClick={handleGoBack}
                    className="flex items-center gap-2 bg-gray-600 text-white px-6 py-2 rounded-lg hover:bg-gray-700 transition-colors"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Go Back
                </button>
            </div>
        </div>
    )
}

const ProductErrorBoundary: React.FC<ProductErrorBoundaryProps> = ({ children }) => {
    return (
        <ErrorBoundary 
            fallback={<ProductErrorFallback />}
            onError={(error, errorInfo) => {
                // Product-specific error handling
                console.group('🛍️ Product Error Details')
                console.error('Product component error:', error)
                console.error('Error info:', errorInfo)
                console.groupEnd()
            }}
        >
            {children}
        </ErrorBoundary>
    )
}

export default ProductErrorBoundary